// const  = ()
import React, { useState } from 'react';

import { Alert, Box, Button, Grid, Stack, Typography } from '@mui/material';
import ImportCountDefault from '@/components/Base/ImportCountDefault';
import { ArrowBack, VerticalAlignBottomTwoTone } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import TableHeaderRecomendacao from '@/components/Base/TableHeaderRecomendacao';
import NewRecomentadionModal from '@/components/Base/NewRecomentadionModal';
import { TitlePages } from '@/components/Base/TitlePage';
import { useConsolidationForStudent } from '@/features/dashboard/api/getConsolidationSummaryForStudent';

export const RecomendacoesAlunosRaiox = () => {
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const location = useLocation();
  const { id, name } = location.state || {};
  const navigate = useNavigate();

  const { data: summary, isError, refetch, isFetching } = useConsolidationForStudent(id);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <NewRecomentadionModal
        id={id}
        name={name || ''}
        open={openModal}
        handleClose={() => setOpenModal(false)}
        submit={() => console.log('teste')}
      />
      <ImportCountDefault open={open} handleClose={handleClose} />

      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Stack flexDirection={'row'} alignItems={'center'}>
          <ArrowBack
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          />
          <TitlePages title={'Recomendações para o aluno'} />
        </Stack>

        <Stack flexDirection={'row'} gap={'20px'}>
          <Button
            sx={{
              p: '0 15px',
              borderRadius: '24px',
              fontSize: '14px',
              height: '37px',
              color: '#fff !important',
              weight: '600',
              background: '#15AB51',
              fontWeight: 'bold',
            }}
            variant="contained"
            onClick={() => setOpenModal(true)}
          >
            Adicionar nova recomendação
          </Button>
        </Stack>
      </Stack>

      <Box
        padding={'15px'}
        sx={{
          border: '1px solid rgba(176, 176, 176, 1)',
          background: '#fff',
          borderRadius: '14px',
        }}
      >
        {isError && (
          <Alert
            severity="error"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  refetch();
                }}
              >
                Atualizar
              </Button>
            }
          >
            Não foi possível carregar as informações!
          </Alert>
        )}

        <TableHeaderRecomendacao data={summary ? summary : []} />
      </Box>
    </>
  );
};
